import { Component, OnInit, ChangeDetectionStrategy } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { ToastService } from '../../../main/services';
import {Contract, Tender} from '../../models';
import moment, { Moment } from 'moment';
import {PlattsPricesService} from '../../../indexes/services';

@Component({
    selector: 'jft-tender-index-analysis-years',
    templateUrl: './tender-contract-dashboard-index-analysis-years.component.html',
    styleUrls: ['./tender-contract-dashboard-index-analysis-years.component.scss'],
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})
export class TenderContractDashboardIndexAnalysisYearsComponent implements OnInit {
    public tender: Tender;
    public contract: Contract;
    public years: number = 2;
    public loading: boolean = false;
    public currency: string;
    public unit: string;
    public yearComparison: boolean = false;

    public onChartPlattsData: any[] = [];
    public allPlattsData: any[] = [];

    public plattsId: number;
    public bateId: string;

    public yearsCollection = [
        {id: 2, name: '2 Last Years'},
        {id: 3, name: '3 Last Years'},
        {id: 4, name: '4 Last Years'},
    ];

    public colorScheme1 = [
            '#1f77b4', '#ff7f0e', '#2ca02c', '#d62728', '#CFC0BB', '#b443a4', '#a8385d', '#aae3f5', '#E44D25', '#fdff34'
        ];

    constructor(
        protected toast: ToastService,
        private route: ActivatedRoute,
        private plattsPricesService: PlattsPricesService,
    ) {
    }

    ngOnInit() {
        let data = this.route.parent.parent.snapshot.data,
            parentParentData = this.route.parent.parent.parent.parent.snapshot.data;
        this.contract = data['contract'];
        this.tender = parentParentData['tender'];
        this.setDefaultFormFields();
    }

    private setDefaultFormFields() {
        this.unit = String(this.tender.unitsId);
        this.currency = String(this.tender.currencyId);
    }

    public onYears(event) {
        this.years = event;
        if (this.plattsId && this.bateId) {
            this.renderChart()
        }
    }

    public addPlatts(event) {
        this.plattsId = event.plattsId;
        this.bateId = String(event.bateId);
        this.renderChart();
    }

    private updateGraph() {
        this.onChartPlattsData = [];
        this.onChartPlattsData = Object.assign([], this.allPlattsData);
    }

    public resetGraph() {
        this.onChartPlattsData = [];
        this.allPlattsData = [];
    }

    public renderChart() { //todo reactor
        this.loading = true;
        this.yearComparison = true;
        this.resetGraph();

        for (let i = 1; i <= this.years; i++) {
            let startDayYear = this.getStartYearDate(i);
            let endDayYear = this.getEndDayYear(i);

             let params = {
                bate: this.bateId,
                dateRange: 'custom',
                currency: this.currency,
                unit: this.unit,
                startDate: startDayYear,
                endDate: endDayYear,
            };

        this.plattsPricesService.fetch(this.plattsId, params).subscribe(
            (data: any) => {
                this.allPlattsData.push(data);
                this.updateGraph();
                this.loading = false;
            }, (error) => {
                this.loading = false;
                this.toast.error(error);
            });
        }
    }

    public deleteGraph(index: number) {
        this.allPlattsData.splice(index, 1);
        this.updateGraph();
    }

    public getLabelColor(i) {
        if (this.colorScheme1.length > i) {
            return this.colorScheme1[i]
        }
        return this.colorScheme1[this.colorScheme1.length - 1]
    }

    private getEndDayYear(i: number) {
        if (i === 0) {
            return moment().format('YYYY-MM-DD');
        }
        return moment().subtract(i, 'year').endOf('year').subtract(1, 'day').format('YYYY-MM-DD');
    }

    private getStartYearDate(i: number) {
        return moment().subtract(i, 'year').startOf('year').format('YYYY-MM-DD');
    }
}
